<template>
  <el-card :shadow="shadow" @click.native="onSelectRecipe" class="recipe-card">
    <div slot="header">
      <span class="title">{{recipe.Title}}</span>
      <span style="float: right; padding: 0 0" type="text">{{recipe.Rating}} upvotes</span>
    </div>
    <span>
      <i>{{recipe.Ingredients.length}} Ingredients</i>
    </span>
    <br>
    <span>{{recipe.Instructions.substring(0,95)}}...</span>
  </el-card>
</template>

<script>
export default {
  props: ['recipe', 'shadow'],
  methods: {
    onSelectRecipe() {
      this.$router.push({
        name: 'Recipe',
        params: { recipeParam: this.recipe },
        query: { id: this.recipe.Id }
      })
    }
  }
}
</script>

<style scoped>
.recipe-card {
  cursor: pointer;
}
.title {
  font-weight: 525;
}
</style>
